<template>
  <div class="loading-wrap" :style="{'background-color': background}" v-show="visible">
    <div class="turn-wrap">
      <img class="turn" style="width: 46px;height: 46px;" src="@/assets/images/loading.png" />
      <div class="c-text">{{loadingText}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      background: null,
      visible: false,
      customClass: '',
      fullscreen: true,
      loadingText: '',
    }
  }
}
</script>

<style lang="less" scoped>
.loading-wrap {
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
}
.turn-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.turn {
  animation: turn 1s linear infinite;
  background: none;
}

@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }

  25% {
    -webkit-transform: rotate(90deg);
  }

  50% {
    -webkit-transform: rotate(180deg);
  }

  75% {
    -webkit-transform: rotate(270deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
.c-text {
  line-height: 50px;
  font-size: 28px;
  color: #f50;
  padding-top: 20px;
  text-shadow: rgba(255, 85, 0, 0.5) 0 0 5px;
}
</style>
